import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { findCampaignsByUserId } from 'components/graphql/queries'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { ClipLoader } from 'react-spinners';

import UserDucks from 'stores/ducks/User.duck';
import CampaignsList from './CampaignsList';


const CampaignsPage: React.FC<{ [label: string]: any }> = (props: any) => {

    if (props.user.id === '') {
        // Wait until user object is retrieved and verified
        return null;
    }

    const [loading, setLoading] = useState(true)
    const [campaigns, setCampaigns] = useState([])

    useEffect(() => {
        if (props.user.id === '') {
            return;
        }
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: findCampaignsByUserId,
                variables: {
                    userId: props.user.id
                }
            })
            .then(res => {
                setCampaigns(res.data.data.campaign.findByUserId)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
            })

    }, [setCampaigns, setLoading, props.user])

    if (loading) {
        return <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
            <div className="w-100 text-center" style={{ paddingTop: '50px' }}>
                <ClipLoader color={"#000"} loading={true} />
            </div>
        </div>
    }

    return <CampaignsList campaigns={campaigns} />
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state)
});

export default connect(mapStateToProps)(CampaignsPage);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsPage/Campaigns.tsx